import { FeatureFlagKey } from "@salestrak/feature-flags";
import { useFeatureFlags } from "#app/hooks/use-feature-flags";

/**
 * Whether the `WIDGETS` flag is enabled for the active workspace.
 *
 * Gates the widget system's routes (`/my-work`, the workflow/team Dashboard
 * tabs). Returns `false` until flags have resolved, so the gated UI stays
 * hidden during the initial fetch.
 */
export function useWidgetsFlag(): boolean {
  const { ready, hasFlag } = useFeatureFlags();
  return ready && hasFlag(FeatureFlagKey.WIDGETS);
}
